import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ScanSessionPage from './components/ScanSessionPage';
import './index.css';

const scanMatch = window.location.pathname.match(/\/scan-session\/([A-Z0-9]+)/i);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {scanMatch ? <ScanSessionPage sessionId={scanMatch[1]} /> : <App />}
  </StrictMode>,
);